/**
 * Created by tomere on 15/04/2018.
 */

import VIEW_MODES from '../../../../../../core/enums/view-modes.types';

export default class AqlQueryCreateEditService {

	constructor($rootScope, JFrogModal, JFrogEventBus, JFrogNotifications) {
		this.$rootScope = $rootScope;
		this.modal = JFrogModal;
		this.jFrogEventBus = JFrogEventBus;
		this.jfrogNotifications = JFrogNotifications;
	}

	/**
	 *  launch the distribution modal
	 */
	showAqlQueryModal(queryModel, onSubmit, viewMode, spec, showQueryForm) {
		this.modalScope = this.$rootScope.$new();
		this.modalScope.header = showQueryForm ? 'Add Query' : 'Add AQL Query';
		this.modalScope.submitAction = 'Save';
		this.modalScope.cancelAction = VIEW_MODES.READ === viewMode ? 'Close' : 'Cancel';
		this.modalScope.showSubmit = VIEW_MODES.READ !== viewMode;
		this.modalScope.showQueryForm = showQueryForm;

		this.modalScope.wizardApi = {
			step: 0
		};

		this.modalScope.formData = {
			aqlQueryModel: queryModel,
			viewMode: viewMode,
			isValidQuery: false,
			allQueries: spec.queries
		};

		this.modalScope.closeModal = () => {
			return this.modalInstance.close();
		};
		this.modalScope.onNextClick = () => {
			this.modalScope.wizardApi.onStepChange('up');
		};
		this.modalScope.onBackClick = () => {
			this.modalScope.wizardApi.onStepChange('down');
		};

		this.modalScope.onSubmit = () => {
			if (onSubmit && typeof onSubmit === 'function') {
				this.modalScope.closeModal();
				onSubmit(this.modalScope.formData.aqlQueryModel);
			}
		};

		this.modalInstance = this.modal
		                         .launchModalWithTemplateMarkup(require('./aql.query.create.edit.service.modal.html'),
			                         this.modalScope, 1000, false);

	};

}

AqlQueryCreateEditService.META = {
	name: 'AqlQueryCreateEditService'
};

AqlQueryCreateEditService.$inject = ['$rootScope',
                                     'JFrogModal',
                                     'JFrogEventBus'
];



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/aqlQueryCreateEditService/aql.query.create.edit.service.js